module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAGZJREFUGBlj/FhQsJCJiWkTb1/fWgYk8LmoKPjfv39+QDmmTX///VsMEoDJg9ggMZAcI0gQJsDMxBQL4oMkQWyQqWAFyIpAbJgkiM0EIvABwlYg2w/zCbIYE8gryHaCrAMpBImB5ABwHVCoTngwmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-login-2018/red_close.png
// module id = 712
// module chunks = 1